import React from "react"
import Layout from '../components/layout'

import BlogPage from "../components/blog/component"

const Blog = () => {

  return (
    <Layout>
      <BlogPage />
    </Layout>
  )
}

export default Blog